import React from 'react';
import styles from './IconLink.module.scss';

function IconLink(props) {
   const {link, title, icon} = props;
   return (
      <a href={link} target={"_blank"} rel="noopener noreferrer" className={styles.iconLink}>
         <i className={icon}/> {title}
      </a>
   );
}

export default IconLink;